import type { BookableOptionValue } from "@@/shared/acquire/resource-reference-options/bookable-option-value";
import { bookableOptionValueZodSchema } from "@@/shared/acquire/resource-reference-options/bookable-option-value-zod-schemas";
import type {
    ResourceReservationId} from "@@/shared/acquire/resources/resource-reservation-id";
import {
    resourceReservationIdZodSchema,
} from "@@/shared/acquire/resources/resource-reservation-id";
import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";

const orderStatusBookableReservationUpdatedZodSchema =
    _orderStatusBaseZodSchema.merge(
        z.object({
            type: z.literal("BOOKABLE_TABLE_RESERVATION_UPDATED"),
            reservationId: resourceReservationIdZodSchema,
            changedBy: userIdZodSchema,
            old: z.array(bookableOptionValueZodSchema),
            new: z.array(bookableOptionValueZodSchema),
        })
    );
type OrderBookableReservationUpdated = z.infer<
    typeof orderStatusBookableReservationUpdatedZodSchema
>;

const orderStatusBookableReservationUpdatedFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly from: BookableOptionValue[];
    readonly to: BookableOptionValue[];
    readonly reservationId: ResourceReservationId;
    readonly changedBy: UserId;
}): OrderBookableReservationUpdated => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: "BOOKABLE_TABLE_RESERVATION_UPDATED",
    changedBy: params.changedBy,
    old: params.from,
    new: params.to,
    reservationId: params.reservationId,
});

export {
    orderStatusBookableReservationUpdatedFactory,
    orderStatusBookableReservationUpdatedZodSchema,
};
export type { OrderBookableReservationUpdated };
